<template>
    <el-dialog :before-close="close" :title="title" :visible.sync="dialog.visible" width="350px">
        <el-input placeholder="请输入分类名" v-model="form.name" />
        <span slot="footer">
            <el-button @click="close">取消</el-button>
            <el-button @click="handleCreate" type="primary">确定</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { DIALOG, DIALOG_EDIT, DIALOG_ADD } from '../../libs/enum.js';

const { mapState, mapActions } = createNamespacedHelpers('resource');

export default {
    data() {
        return {
            DIALOG_EDIT,
        };
    },
    computed: {
        ...mapState({
            dialog: state => state.labelDialog,
            form: state => state.labelForm,
        }),
        title() {
            return `${DIALOG[this.dialog.type]}分类`;
        },
    },
    methods: {
        ...mapActions(['changeLabelDialog', 'createLabel']),
        close() {
            this.changeLabelDialog({ visible: false });
        },
        handleCreate() {
            this.dialog.type === DIALOG_ADD ? this.createLabel() : '';
        },
    },
};
</script>
